import React from 'react';
import { Link } from 'react-router-dom';
import { pageStyle, cardStyle, brandStyle, titleStyle, textStyle, secondaryButtonStyle, helperLinkStyle } from './components/authPageStyles';

function NotFound() {
  return (
    <main style={pageStyle}>
      <section style={cardStyle}>
        <div style={brandStyle}>RE</div>
        <h1 style={titleStyle}>Página não encontrada</h1>
        <p style={textStyle}>O endereço acessado não existe ou o link está incompleto. Confira o link recebido por e-mail ou volte para o site.</p>
        <Link to="/" style={secondaryButtonStyle}>Voltar para o site</Link>
        <div style={{ marginTop: '18px' }}>
          <Link to="/recuperar-senha" style={helperLinkStyle}>Recuperar senha</Link>
        </div>
      </section>
    </main>
  );
}

export default NotFound;
